"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddAttributesToNode = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const product_tree_nodes_1 = require("../../product-tree-nodes");
const add_attribute_mutation_1 = require("../add-attribute.mutation");
const useAddAttributesToNode = () => {
    const [addAttributeMutation] = (0, react_2.useMutation)(add_attribute_mutation_1.ADD_ATTRIBUTE);
    const addAttributesToSeveralNodes = (0, react_1.useCallback)((attributes, treeNodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        const variableList = [];
        for (const attribute of attributes) {
            for (const treeNodeId of treeNodeIds) {
                variableList.push([attribute, treeNodeId]);
            }
        }
        const promises = variableList.map(([{ name: label, description, values }, treeNodeId]) => new Promise((resolve, reject) => {
            void addAttributeMutation({
                variables: {
                    productLabelValidation: {
                        label,
                        description,
                        productTreeNode: treeNodeId,
                        allowedValues: values.map(({ name, description }) => ({ value: name, description: description || null })),
                        clientMutationId: '',
                        includeDescendants: false,
                        includeAncestors: false,
                    },
                    sort: [{ distance: graphql_1.SortOrder.Asc }],
                },
                onError: (error) => reject(new Error(error.message)),
                onCompleted: (data) => resolve(data.addProductLabelValidation),
            });
        }));
        const results = yield Promise.all(promises);
        const errors = results.filter(({ error }) => error).map(({ error }) => error);
        const errorMessage = errors.join(', ');
        if (errorMessage) {
            throw new Error(errorMessage);
        }
        const updatedPaths = (0, product_tree_nodes_1.getTreeNodePaths)(results.map(({ productTreeNode }) => productTreeNode));
        return updatedPaths;
    }), [addAttributeMutation]);
    return {
        addAttributesToSeveralNodes,
    };
};
exports.useAddAttributesToNode = useAddAttributesToNode;
exports.default = exports.useAddAttributesToNode;
